import {Pinia} from 'pinia'
import {RouteLocationNormalized} from 'vue-router'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {useDeploymentVersionStore} from '@toolify/client/src/stores/DeploymentVersionStore/useDeploymentVersionStore'

export function forceDeploymentUpdateRouterHookFactory(pinia: Pinia) {
  return function forceDeploymentUpdateRouterHook(to: RouteLocationNormalized) {
    const deploymentVersionStore = useDeploymentVersionStore(pinia)
    if(deploymentVersionStore.mustUpdate && to.name !== RouteName.Changelog) {
      return {name: RouteName.Changelog}
    }
  }
}
